import axios from 'axios';
import type { OcrResponse } from '../types/apiTypes';

export const performOCR = async (base64Image: string): Promise<string | null> => {
  try {
    const response = await axios.post<OcrResponse>('/api/ocr', {
      image: base64Image,
    });
    return response.data.text;
  } catch (error: unknown) {
    console.error('Error performing OCR:', error);
    return null;
  }
};
